<template>
    <div class="cart">
        <button v-if="!view" type="button" class="none dropdown-toggle" data-toggle="dropdown">
            <span class="number" v-if="count">{{ count }}</span>
            <i class="material-icons">shopping_cart</i>
        </button>
        <div class="dropdown-menu stop pull-right">
            <ul v-if="count == 0 && !view">
                <li>{{ _('Váš nákupný košík je prázdny.') }}</li>
            </ul>
            <ul v-if="totalCartPrice > 0" v-bind:class="{ overLimit : count > 5 }">
                <li v-for="(item, id) in basket">
                    <h6>
                        <a class="change-quantity pull-left" v-if="!hide && item.quantity > 1" @click.prevent="changeQuantity(id, item, -1)" href="#">-</a>
                        <a class="change-quantity fa fa-remove red pull-left" v-if="!hide && item.quantity == 1" @click.prevent="removeItem(id)" href="#"></a>
                        {{ limit(item.product.name, 24) }} <span v-if="item.product.variant" class="variant">{{ item.product.variant }}</span>

                        <a class="change-quantity pull-right" v-if="!hide && item.quantity < item.product.quantity" @click.prevent="changeQuantity(id, item, 1)" href="#">+</a>
                        <span class="quantity">{{ item.quantity }} x <strong>{{ toPrice(itemPrice(item)) }} €</strong></span>
                    </h6>
                </li>
                <li v-for="product in getAdditional">
                    <h6>
                        {{ limit(product.name, 24) }} <span v-if="product.variant" class="variant">{{ product.variant }}</span>

                        <span class="quantity">{{ product.quantity }} x <strong>{{ toPrice(product.price) }} €</strong></span>
                    </h6>
                </li>
            </ul>
            <ul v-if="totalCartPrice > 0">
                <li class="none-border">
                    <h6>
                        <strong class="sum">Spolu</strong> <span class="pull-right summary">{{ totalCartPrice }} €</span>
                    </h6>
                    <div class="cart-buttons" v-if="!view">
                        <a v-bind:href="showBasket"><button class="btn view-btn">Zobraziť košík</button></a>
                        <a v-bind:href="showBasket"><button class="btn blue-btn add-btn">Objednať</button></a>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import Core from './core.js';

    export default {
        props : ['basket', 'view', 'hide'],

        data(){
            return {
                showBasket : window.Laravel.requests.basket.index,
            };
        },

        computed: {
            getAdditional : Core.computed.getAdditional,
            isContractor : Core.computed.isContractor,
            getAdditionalPrice: Core.computed.getAdditionalPrice,
            count(){
                return Object.keys(this.basket).length;
            },
            totalCartPrice(){
                var price = 0;

                for ( var key in this.basket ) {
                    price += this.itemPrice(this.basket[key]) * parseInt(this.basket[key].quantity);
                }

                return this.toPrice(price + this.getAdditionalPrice);
            },
        },

        methods: {
            itemPrice : Core.methods.itemPrice,
            toPrice(price){
                return parseFloat(price).toFixed(2);
            },
            limit(title, limit){
                if ( ! limit )
                    var limit = 20;

                return (''+title).length > limit ? (title.substr(0, limit) + '...') : title;
            },
            removeItem : Core.methods.removeItem,
            changeQuantity(id, item, add){
                var quantity = parseInt(item.quantity) + parseInt(add);

                this.basket[id].quantity = quantity;

                if ( window.quantityTimeout )
                    clearTimeout(window.quantityTimeout);

                window.quantityTimeout = setTimeout(function(){
                    $.get(window.Laravel.requests.basket.update, { item_id : id, quantity : quantity });
                }.bind(this), 300);
            }
        }
    }
</script>